var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.style.infoBlock, _vm.needBorder ? _vm.style.infoBlockBordered : '']},[_c('div',{class:_vm.style.infoBlockHeader},[_c('h5',[_vm._v(" "+_vm._s(_vm.header)+" ")]),_vm._t("link")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }